import { InicioComponent } from './components/inicio/inicio.component';
import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { UserService } from './services/user.service';
import { GLOBAL } from 'src/app/services/global';
import { Title } from '@angular/platform-browser';
import localeCL from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeCL, 'cl');
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [UserService]

})
export class AppComponent implements AfterViewInit{  
  title = GLOBAL.nombreMuni.toUpperCase();
  identity;
  form;
  token;
 
  constructor( public dialog: MatDialog, private _userService: UserService, private elementRef: ElementRef,private titleService: Title){

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    titleService.setTitle(`Smart DOM - MUNICIPALIDAD DE ${GLOBAL.nombreMuni.toUpperCase()}`);

  }

  ngDoCheck(){
    
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();   
    
  }

  ngAfterViewInit(){
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#EBEBEB';
 }


}
